import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ConfirmationService, Message} from "primeng/primeng";
import {Inventario} from "../inventario/inventario";
import {Tienda} from "../tienda/tienda";
import {PosService} from "../Services/pos.service";
import {Producto} from "../producto/producto";
import {ActivatedRoute} from "@angular/router";
import {ListaPrecioService} from "../Services/listaPrecio.service";
import {ComboService} from "../Services/combo.service";
import {Combo} from "../combo/combo";
import {ClienteService} from "../Services/clientes.service";
import {Cliente} from "../cliente/cliente";
import {UrlService} from "../Services/url.service";

@Component({
  selector: 'app-pos',
  templateUrl: './pos.component.html',
  styleUrls: ['./pos.component.css']
})
export class POSComponent implements OnInit {


  msgs: Message[] = [];
  formPos: FormGroup;
  formCliente : FormGroup;
  btnNuevo = true;
  btnCancelar = false;
  btnGuardar = false;
  btnGuardarEditar = false;
  panelRequeridos = false;
  loading = false;
  tipoGuardado = '';
  ProductosRegistrados:Inventario[];
  ProductosPos : Inventario[] = [];
  cantidad = '';
  TiendasRegistrados:Tienda[];
  lista = new Object();
  tiendaId = 0;
  factura = '';
  totalFactura = 0;
  verFechaRetiro = false;
  CombosRegistrados:Combo[];
  ClientesRegistrados:Cliente[];
  ClienteSeleccionado:Cliente = '';
  verClientes = true;
  separado = false;
  separadoId='';
  AddCliente = false;
  verTarjetas = false;
  efectivoEntregado;
  tipoFactura = true;
  toogle= true;

  constructor(private URL:UrlService,
              private servicioCliente:ClienteService,
              private servicioCombo:ComboService,
              private fb: FormBuilder,
              private servicioLista:ListaPrecioService,
              private servicioPos:PosService,
              private route: ActivatedRoute,) { }

  ngOnInit() {
    this.crearControlesPos();
    this.crearControlesCliente();
    this.obtenerParmTiendaId();
    this.listarProductos();
    this.listarCombos();
    this.listarClientes();
  }

  crearControlesPos(){
    this.formPos = this.fb.group({
      descuento:['',Validators.required],
      metodoPago:['efectivo',Validators.required],
      tipoTarjeta:['',Validators.required],
      efectivo:['',Validators.required],
      cambio:['',Validators.required],
      total:['',Validators.required],
      fechaRetiro:[''],
      nFactura:['']
      }
    );

  }
  crearControlesCliente(){
    this.formCliente = this.fb.group({
        nit:['',Validators.required],
        nombre:['',Validators.required],
        direccion:[''],
        telefono:['',Validators.required],
        email:[''],

      }
    );

  }
  mensajes(severity,summary,detail){
    this.msgs = [];
    this.msgs.push({severity:severity, summary:summary, detail:detail});
  }
  listarProductos(){
    this.loading = true;
    this.servicioLista.getListaByTienda(this.tiendaId)
      .subscribe(
        rt => {
          this.ProductosRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  Mover(item:any){
    this.totalFactura = 0;
      let prod = [...this.ProductosPos];

      item['tipo'] = 'producto';
      item['unidad'] = item.unidad;
    if(item['unidad'] == 'metro'){
      item['cantidad'] = 0;
    }else {
      item['cantidad'] =1;
    }

      item['descuento'] = 0;
    let preciofinal = 0;

      if(item['descuentoIndividual'] === undefined){
        preciofinal = item['precio'];
      }else {
        preciofinal= item['precio']- ((item['precio']* item['descuentoIndividual'])/100);
        item['precio'] = preciofinal;
      }

      item['total_unitario'] = item['cantidad'] * preciofinal ;
      prod.push(item);
      this.ProductosPos = prod;
    for(let item of this.ProductosPos){
      this.totalFactura += item['total_unitario'];
    }

  }
  MoverCombo(item:any){
    this.totalFactura = 0;
    let prod = [...this.ProductosPos];
    item['tipo'] = 'combo';
    item['cantidad'] = 1;
    item['descuento'] = 0;
    item['total_unitario'] = item['cantidad'] * item['precio'] ;
    prod.push(item);
    this.ProductosPos = prod;
    for(let item of this.ProductosPos){
      this.totalFactura += item['total_unitario'];
    }
    console.log(this.ProductosPos);
  }
  BorrarProdPos(item:Producto){
    let prod = [...this.ProductosPos];
    let indice = prod.indexOf(item);
    prod.splice(indice,1);
    this.ProductosPos = prod;
    this.totalFactura -= item['total_unitario'];
  }
  generarPos(){
    this.loading = true;
    let Pos = {
      productos:this.ProductosPos,
      totalFactura:this.totalFactura,
      tienda_id:this.tiendaId,
      descuento : this.formPos.value['descuento'],
      metodoPago : this.formPos.value['metodoPago'],
      tipoTarjeta : this.formPos.value['tipoTarjeta'],
      efectivo : this.formPos.value['efectivo'],
      cambio : this.formPos.value['cambio'],
      fechaRetiro : this.formPos.value['fechaRetiro'],
      numFactura:this.formPos.value['nFactura'],
      cliente_id: this.ClienteSeleccionado.id,
      sistema:this.tipoFactura
    };
    if (this.tipoFactura){

      this.servicioPos.addDetallePos(Pos)
        .subscribe(
          rt => {
            this.mensajes('success','Guardar',rt['mensaje']);
            this.factura = rt['factura'];
            this.separadoId = rt['separado'];
            if(this.separado == true){
              let url:string = this.URL.getLocal()+'/separado/imprimir/'+this.separadoId;
              window.open(url,'blank');

            }else if (this.separado == false){
              let url:string = this.URL.getLocal()+'/factura/imprimir/'+this.factura;
              window.open(url,'blank');
            }
            this.separado = false;
            this.loading = false;
            this.listarProductos();
            this.listarCombos();
          },
          er => {
            this.mensajes('error','Error',er);
            this.loading = false;
          },
          () =>  {

            this.Cancelar();
            this.formPos.patchValue({
              efectivo : 'efectivo'
            })
          });
    }else {

      this.servicioPos.addDetallePos(Pos)
        .subscribe(
          rt => {
            this.mensajes('success','Guardar',rt['mensaje']);
            this.separado = false;
            this.loading = false;
            this.listarProductos();
          },
          er => {
            this.mensajes('error','Error',er);
            this.loading = false;
          },
          () =>  {

            this.Cancelar();
            this.formPos.patchValue({
              efectivo : 'efectivo'
            })
          });
    }
  }
  obtenerParmTiendaId(){
    this.route.params
      .subscribe(params => {
        const _id = params['id'].toString();
        this.tiendaId = _id;
      });
  }
  SumarTotal(item:any){
      let indice = this.ProductosPos.indexOf(item);
      let producto = this.ProductosPos[indice];
      if(producto['can'] >item.cantidad){
        item.cantidad += 1;
        this.ProductosPos[indice]['total_unitario'] += parseInt(producto['precio']);
        this.ProductosPos[indice]['cantidad'] = item.cantidad;
        this.totalFactura += parseInt(producto['precio']);

      }else{
        this.mensajes('warn','Atencion','La cantidada vender es mayor a la cantidad existente!')
      }
  }
  sumarCantidadMetros(item:any){
    let indice = this.ProductosPos.indexOf(item);
    let producto = this.ProductosPos[indice];
      this.ProductosPos[indice]['total_unitario'] += parseInt(producto['precio']);
      this.ProductosPos[indice]['cantidad'] = item.cantidad;
      item.total_unitario = parseInt(producto['precio'])*parseFloat(item.cantidad);
      this.totalFactura += item.total_unitario;

  }
  RestarTotal(item:any){

    let indice = this.ProductosPos.indexOf(item);
    let producto = this.ProductosPos[indice];
    if(item.cantidad > 1){
      item.cantidad -= 1;
      this.ProductosPos[indice]['total_unitario'] -= parseInt(producto['precio']);
      this.ProductosPos[indice]['cantidad'] = item.cantidad;
      this.totalFactura -=  parseInt(producto['precio']);
    }
  }
  calcularCambio(){
    let efectivo = this.efectivoEntregado;
    this.formPos.patchValue({
      cambio: efectivo - this.totalFactura
    });
    if(efectivo < this.totalFactura && this.ClienteSeleccionado) {
      this.verFechaRetiro = true;
      this.separado = true;
    }else if(efectivo < this.totalFactura && this.ClienteSeleccionado == ''){
      this.mensajes('warn','Atencion','Debe seleccionar un cliente para el separado');
      this.verClientes = false;
      this.separado = true;
    }
  }
  Cancelar(){
   this.ProductosPos = [];
   this.totalFactura = 0;
   this.formPos.reset();
   this.verFechaRetiro = false;
   this.ClienteSeleccionado = '';
   this.listarCombos();
   this.listarProductos();
    this.toogle = true;
  }
  aplicarDescuento(){
    this.totalFactura = this.totalFactura - (this.totalFactura * (this.formPos.value['descuento']/100));
    this.toogle = false;
  }
  listarCombos(){
    this.loading = true;
    this.servicioCombo.getComboByTienda(this.tiendaId)
      .subscribe(
        rt => {
          this.CombosRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  listarClientes(){
    this.loading = true;
    this.servicioCliente.getCliente()
      .subscribe(
        rt => {
          this.ClientesRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  seleccionarCliente(item:Cliente){
    this.ClienteSeleccionado = item;
    this.verFechaRetiro = true;
  }
  calculatTarjetas(dato){

    let metodo = this.formPos.value['metodoPago'];
    let tipo = dato;

    let visaDebito = this.totalFactura * (1.44/100);
    let visaCredito = this.totalFactura * (1.84/100);
    let visaElectron = this.totalFactura * (1.11/100);
    let visaInternacional = this.totalFactura * (1.48/100);

    let MasterDebito = this.totalFactura * (1.58/100);
    let MasterCredito = this.totalFactura * (1.88/100);
    let MasterInternacional = this.totalFactura * (1.61/100);

    let amexCredito = this.totalFactura * (1.86/100);
    let amexInternacional = this.totalFactura * (1.55/100);

    /*************************VISA***************************/

    if(metodo == 'visa' && tipo == 'debito'){
      this.totalFactura +=  visaDebito;
    }
    if(metodo == 'visa' && tipo == 'credito'){
      this.totalFactura +=  visaCredito;
    }
    if(metodo == 'visa' && tipo == 'electron'){
      this.totalFactura +=  visaElectron;
    }
    if(metodo == 'visa' && tipo == 'internacional'){
      this.totalFactura +=  visaInternacional;
    }

    /***************************MASTER*************************/

    if(metodo == 'master' && tipo == 'debito'){
      this.totalFactura +=  MasterDebito;
    }
    if(metodo == 'master' && tipo == 'credito'){
      this.totalFactura +=  MasterCredito;
    }
    if(metodo == 'master' && tipo == 'internacional'){
      this.totalFactura +=  MasterInternacional;
    }


    /*************************AMEX***************************/

    if(metodo == 'amex' && tipo == 'credito'){
      this.totalFactura +=  amexCredito;
    }
    if(metodo == 'master' && tipo == 'internacional'){
      this.totalFactura +=  amexInternacional;
    }

    this.totalFactura = Math.round(this.totalFactura);
  }
  validarEfectivo(){
    if(this.formPos.value['efectivo']){
      return true
    }else {
      return false;
    }
  }
  addCliente(){
    this.AddCliente = true;
    this.formCliente.reset();
  }
  guardarNuevoCliente() {
    this.loading = true;
    this.servicioCliente.addCliente(this.formCliente.value)
      .subscribe(
        rt => {
          this.mensajes('success', 'Guardar', rt);
          this.listarClientes();
          this.loading = false;
          this.AddCliente = false;
        },
        er => this.mensajes('error', 'Error', er),
        () => {
        });
  }
  seleccionarTarjeta(dato){
    if(dato == 'efectivo'){
      this.verTarjetas = false;
    }else {
      this.verTarjetas = true;
    }

  }

}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/pos/pos.component.ts